/* Added 17 Oct 2026 (W3): mobile sticky add-to-basket bar price line.
   ursa-product-tools.js builds the bar (.upt-sticky) and copies the whole price block text into it
   ("£18.59 GBP £15.49 ex VAT. Free Shipping on…", cut at 40 characters), which is too long for the bar, so the price got cut off.
   This keeps ursa-product-tools.js untouched (it is MD5-pinned) and rewrites that line to just "£18.59 · £15.49 ex VAT"
   (ex VAT only for GBP, where the page shows it). Re-applies whenever the bar rewrites it, e.g. on variant change.
   (Live chat bubble handling moved to ursa-glass.js on 20 Oct 2026.)
   To undo: delete this file and its script line in layout/theme.liquid. */
(function () {
  function shortPrice() {
    var block = document.querySelector('product-price');
    if (!block) return '';
    var price = block.querySelector('.price');
    var main = price ? price.textContent.replace(/\s+/g, ' ').trim().replace(/\s+[A-Z]{3}$/, '') : '';
    var exVat = block.querySelector('.price-exc-vat');
    var ex = exVat ? exVat.textContent.replace(/\s+/g, ' ').trim().replace(/\s+[A-Z]{3}$/, '') : '';
    return main && ex ? main + ' · ' + ex + ' ex VAT' : main;
  }

  function fix(span) {
    var want = shortPrice();
    if (want && span.textContent !== want) span.textContent = want;
  }

  function watch(bar) {
    var span = bar.querySelector('.upt-sticky__t span');
    if (!span || span.dataset.ursaShort) return;
    span.dataset.ursaShort = '1';
    fix(span);
    new MutationObserver(function () { fix(span); }).observe(span, { childList: true, characterData: true, subtree: true });
  }

  // The Live chat bubble used to be lifted above the bar here. 20 Oct 2026: it now fades away while the bar shows (see the Live chat block in ursa-glass.js).

  function start() {
    var bar = document.querySelector('.upt-sticky');
    if (bar) return watch(bar);
    var mo = new MutationObserver(function () {
      var b = document.querySelector('.upt-sticky');
      if (b) { mo.disconnect(); watch(b); }
    });
    mo.observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
